export default __webpack_public_path__ + "static/media/storageUnit1-afterD-1024w.22f361e3.webp";